import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import ApiList from "services/apiList";

const initialState = {
  loading: false,
  user: {},
  teacherTypes: [],
  positions: [],
  courses: [],
  code: "",
  form: {
    teacher_type: 0,
    position: 0,
    course: 0,
    gender: true,
    mRole: false,
    tRole: false,
    sRole: false,
    fRole: false,
    chRole: false,
    pRole: false,
    fileName: "No selected file",
    teacherTimeLimit: 30,
    username: "",
    lastname: "",
    firstname: "",
    password: "",
    register: "",
    phone: "",
    email: "",
  },
  error: "",
};

// API CALL

export const addUser = createAsyncThunk(
  "get/add_user",
  async (id, { getState }) => {
    const { form } = getState().userAddEdit;

    var data = {
      username: form.username,
      firstname: form.firstname,
      lastname: form.lastname,
      password: form.password,
      is_manager: form.mRole,
      is_teacher: form.tRole,
      is_student: form.sRole,
      is_food_technologist: form.fRole,
      is_chef: form.chRole,
      is_parent: form.pRole,
      gender: form.gender,
      teacher_time_limit: form.teacherTimeLimit,
    };
    if (form.teacher_type !== 0) {
      data["teacher_type"] = parseInt(form.teacher_type);
    }
    if (form.position !== 0) {
      data["position"] = parseInt(form.position);
    }
    if (form.course !== 0) {
      data["student_course"] = form.course;
    }
    if (form.email !== "" && form.email !== null) {
      data["email"] = form.email;
    }
    if (form.phone !== "" && form.phone !== null) {
      data["phone"] = form.phone;
    }
    if (form.register !== "" && form.register !== null) {
      data["register"] = form.register;
    }

    const response =
      id != null
        ? await axios.put(`${ApiList.userUrl}${id}/`, data) // Update existing user
        : await axios.post(`${ApiList.userUrl}`, data);
    return response.data;
  }
);

export const fetchSelectedUser = createAsyncThunk(
  "get/selected_user",
  async (id) => {
    const response = await axios.get(`${ApiList.userUrl}${id}/`);
    return response.data;
  }
);

export const fetchTeacherTypes = createAsyncThunk(
  "get/teacher_types",
  async () => {
    const response = await axios.get(`${ApiList.lessonTeacherTypeUrl}`);
    return response.data;
  }
);

export const fetchPositions = createAsyncThunk(
  "get/fetch_positions",
  async () => {
    const response = await axios.get(`${ApiList.positionUrl}`);
    return response.data;
  }
);

export const fetchCources = createAsyncThunk("get/fetch_cources", async () => {
  const response = await axios.get(`${ApiList.courseUrl}`);
  return response.data;
});

export const deleteUser = createAsyncThunk("get/delete_user", async (id) => {
  const response = await axios.delete(`${ApiList.userUrl}${id}/`);
  return response.data;
});

export const fetchSelectedUserCourse = createAsyncThunk(
  "get/fetch_user_course",
  async (id) => {
    const response = await axios.get(`${ApiList.userCourseUrl}?uid=${id}`);
    return response.data;
  }
);

export const changeUserPassword = createAsyncThunk(
  "get/change_user_password",
  async (data) => {
    const response = await axios.post(`${ApiList.changePasswordUrl}`, data);
    return response.data;
  }
);

export const fetchAllUserCount = createAsyncThunk(
  "get/all_user_count",
  async () => {
    const response = await axios.get(`${ApiList.allUserCountUrl}`);
    if (response.data) {
      if (response.data.result) {
        if (response.data.result.count && response.data.result.school) {
          let min = 1;
          let max = 10;
          let r = Math.floor(Math.random() * (max - min) + min);
          var code = response.data.result.school.toString();
          if (code.length === 1) {
            code = "00" + code;
          } else if (code.length === 2) {
            code = "0" + code;
          }
          code =
            "U" + code + response.data.result.count.toString() + r.toString();
          return code;
        }
      }
    }
    return "";
  }
);
// ACTIONS
const userAddEditSlice = createSlice({
  name: "userAddEdit",
  initialState,
  reducers: {
    setDefaultInitialState: (state, action) => {
      state.user = {};
      state.code = "";
      state.form = {
        teacher_type: 0,
        position: 0,
        course: 0,
        gender: true,
        mRole: false,
        tRole: false,
        sRole: false,
        chRole: false,
        fRole: false,
        pRole: false,
        fileName: "No selected file",
        username: "",
        lastname: "",
        firstname: "",
        password: "",
        register: "",
        phone: "",
        email: "",
        teacherTimeLimit: 30,
      };
      state.error = "";
    },
    setInitialSate: (state, action) => {
      state.code = "";
      state.form = {
        teacher_type: state.user.teacher_type ?? 0,
        position: state.user.position,
        gender: state.user.gender,
        mRole: state.user.is_manager,
        tRole: state.user.is_teacher,
        sRole: state.user.is_student,
        fRole: state.user.is_food_technologist,
        chRole: state.user.is_chef,
        pRole: state.user.is_parent,
        fileName: state.user.profile,
        username: state.user.username,
        lastname: state.user.lastname,
        firstname: state.user.firstname,
        register: state.user.register,
        phone: state.user.phone,
        email: state.user.email,
        teacherTimeLimit: state.user.teacher_time_limit,
      };
      state.error = "";
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setUserCode: (state, action) => {
      var code = state.code;
      if (state.form.mRole) {
        code = code.replace(code[0], "M");
      } else if (state.form.tRole) {
        code = code.replace(code[0], "T");
      } else if (state.form.sRole) {
        code = code.replace(code[0], "S");
      } else if (state.form.chRole) {
        code = code.replace(code[0], "C");
      } else if (state.form.fRole) {
        code = code.replace(code[0], "F");
      } else if (state.form.pRole) {
        code = code.replace(code[0], "P");
      } else {
        code = code.replace(code[0], "U");
      }
      state.form.username = code;
    },
    setCourse: (state, action) => {
      state.form.course = action.payload;
    },
    setType: (state, action) => {
      state.form.teacher_type = action.payload;
    },
    setGender: (state, action) => {
      state.form.gender = action.payload;
    },
    setPosition: (state, action) => {
      state.form.position = action.payload;
    },
    setMrole: (state, action) => {
      state.form.mRole = action.payload;
    },
    setTrole: (state, action) => {
      state.form.tRole = action.payload;
    },
    setSrole: (state, action) => {
      state.form.sRole = action.payload;
    },
    setChrole: (state, action) => {
      state.form.chRole = action.payload;
    },
    setFrole: (state, action) => {
      state.form.fRole = action.payload;
    },
    setProle: (state, action) => {
      state.form.pRole = action.payload;
    },
    setFileName: (state, action) => {
      state.form.fileName = action.payload;
    },
    setUsername: (state, action) => {
      state.form.username = action.payload;
    },
    setLastname: (state, action) => {
      state.form.lastname = action.payload;
    },
    setFirstname: (state, action) => {
      state.form.firstname = action.payload;
    },
    setPassword: (state, action) => {
      state.form.password = action.payload;
    },
    setRegister: (state, action) => {
      state.form.register = action.payload;
    },
    setPhone: (state, action) => {
      state.form.phone = action.payload;
    },
    setEmail: (state, action) => {
      state.form.email = action.payload;
    },
    setTeacherTimeLimit: (state, action) => {
      const value = action.payload;
      const parsedValue = parseInt(value, 10);

      if (!isNaN(parsedValue)) {
        state.form.teacherTimeLimit = parsedValue;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // ALL USER COUNT (БҮХ ХЭРЭГЛЭГЧИЙН ТОО)
      .addCase(fetchAllUserCount.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllUserCount.fulfilled, (state, action) => {
        state.loading = false;
        state.code = action.payload;
        state.error = "";
      })
      .addCase(fetchAllUserCount.rejected, (state, action) => {
        state.loading = false;
        state.code = "";
        state.error = action.error.message;
      })
      // SELECTED USER
      .addCase(fetchSelectedUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSelectedUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.result || {};
        state.error = "";
      })
      .addCase(fetchSelectedUser.rejected, (state, action) => {
        state.loading = false;
        state.user = [];
        state.error = action.error.message;
      })
      // TEACHER TYPES (ZAAH ARGIIN NEGDEL)
      .addCase(fetchTeacherTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTeacherTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.teacherTypes = action.payload.result || [];
        state.error = "";
      })
      .addCase(fetchTeacherTypes.rejected, (state, action) => {
        state.loading = false;
        state.teacherTypes = [];
        state.error = action.error.message;
      })
      // POSITIONS (ALBAN TUSHAAL)
      .addCase(fetchPositions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPositions.fulfilled, (state, action) => {
        state.loading = false;
        state.positions = action.payload.result || [];
        state.error = "";
      })
      .addCase(fetchPositions.rejected, (state, action) => {
        state.loading = false;
        state.positions = [];
        state.error = action.error.message;
      })
      // COURCES (ANGIUD)
      .addCase(fetchCources.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCources.fulfilled, (state, action) => {
        state.loading = false;
        state.courses = action.payload.result || [];
        state.error = "";
      })
      .addCase(fetchCources.rejected, (state, action) => {
        state.loading = false;
        state.courses = [];
        state.error = action.error.message;
      })
      // ADD USER ( USER NEMEH )
      .addCase(addUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(addUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // STUDENT COURSE  ( СУРАГЧЫН АНГИ )
      .addCase(fetchSelectedUserCourse.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSelectedUserCourse.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.result) {
          if (action.payload.result.id) {
            state.form.course = action.payload.result.id.toString() ?? "";
          }
        }
        state.error = "";
      })
      .addCase(fetchSelectedUserCourse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const {
  setDefaultInitialState,
  setInitialSate,
  setUser,
  setCourse,
  setType,
  setGender,
  setPosition,
  setMrole,
  setSrole,
  setTrole,
  setChrole,
  setFrole,
  setProle,
  setFileName,
  setUsername,
  setLastname,
  setFirstname,
  setPassword,
  setRegister,
  setPhone,
  setEmail,
  setUserCode,
  setTeacherTimeLimit,
} = userAddEditSlice.actions;
export default userAddEditSlice.reducer;
